import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function AboutPage() {
  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "关于我们 - 免费韩国漫画在线阅读 - 尾巴漫画网",
    "description": "尾巴漫画网品牌介绍、用户口碑与联系方式。了解我们致力于为韩漫爱好者提供免费漫画阅读平台的使命。",
    "url": "https://www.weibamanhua.com/about",
    "isPartOf": {
      "@type": "WebSite",
      "name": "尾巴漫画网",
      "url": "https://www.weibamanhua.com/"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首页",
        "item": "https://www.weibamanhua.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "关于我们",
        "item": "https://www.weibamanhua.com/about"
      }
    ]
  };

  return (
    <>
      <SchemaOrg schema={webPageSchema} />
      <SchemaOrg schema={breadcrumbSchema} />
      <Navbar />
      <main className="pt-20 pb-14 min-h-screen">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
            <span>/</span>
            <span className="text-foreground-800 font-medium">关于我们</span>
          </nav>
        </div>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="max-w-[900px] mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              关于尾巴漫画
            </h1>
            <p className="text-sm text-foreground-500 mb-8 max-w-2xl mx-auto">
              尾巴漫画网是领先的免费韩国漫画在线阅读平台
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
              <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                <h2 className="text-lg font-heading font-bold text-foreground-900 mb-3">品牌介绍</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  尾巴漫画网成立于2020年，是专注于韩国漫画在线阅读的优质平台。我们致力于为广大韩漫爱好者提供海量、高清、免费的漫画资源。平台汇聚了超过2000部精品韩漫，涵盖恋爱言情、奇幻冒险、动作热血、悬疑推理、耽美BL、搞笑日常等丰富的分类，满足不同读者的口味需求。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                  我们独创的下拉式观看模式，让读者无需繁琐的翻页操作，只需轻松滚动即可畅享流畅的阅读体验。每日更新机制确保读者总能看到最新鲜的韩漫内容，追更不等待。
                </p>
              </div>
              <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                <h2 className="text-lg font-heading font-bold text-foreground-900 mb-3">我们的使命</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  让每一位韩漫爱好者都能轻松找到并阅读自己喜欢的作品，是尾巴漫画网不变的追求。我们相信，优秀的漫画作品应该被更多人看到，而阅读的门槛应该尽可能低。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                  尾巴漫画网持续优化阅读体验，从高清画质到流畅加载，从智能推荐到个性化分类，每一个细节都凝聚着我们对漫画的热爱和对读者的尊重。免费韩国漫画在线阅读，就上尾巴漫画网。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { number: '2000+', label: '精品韩漫', icon: 'ri-book-open-line' },
                { number: '500万+', label: '忠实读者', icon: 'ri-user-heart-line' },
                { number: '每日更新', label: '追更不停', icon: 'ri-refresh-line' },
                { number: '100%', label: '完全免费', icon: 'ri-vip-crown-line' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-3">
                    <i className={`${stat.icon} text-xl text-accent-600`}></i>
                  </div>
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">{stat.number}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  name: '漫画迷小王',
                  content: '尾巴漫画网是我用过最好的韩漫阅读平台！下拉式观看真的太方便了，画质也很高清，每天都会来看看有没有更新。',
                  rating: 5,
                },
                {
                  name: '韩漫爱好者阿琳',
                  content: '分类很全面，想看的类型基本都能找到。而且完全免费，不用注册就能看，体验非常好。推荐给了很多朋友。',
                  rating: 5,
                },
                {
                  name: '追更达人小李',
                  content: '每日更新的速度很快，追的几部漫画都能第一时间看到最新章节。阅读界面也很流畅，没有任何卡顿。',
                  rating: 5,
                },
                {
                  name: '资深漫迷老张',
                  content: '从2020年就开始用尾巴漫画了，见证了平台的成长。现在漫画种类越来越多，品质也越来越好。',
                  rating: 5,
                },
                {
                  name: '新入坑的小白',
                  content: '作为韩漫新手，尾巴漫画的分类和推荐功能帮我找到了很多好看的漫画。现在已经彻底入坑韩漫了！',
                  rating: 5,
                },
                {
                  name: '天天泡在漫画里的喵喵',
                  content: '最爱的漫画平台没有之一！更新及时，画质清晰，下拉阅读体验丝滑流畅。希望平台越来越好！',
                  rating: 5,
                },
              ].map((review) => (
                <div key={review.name} className="bg-background-50 rounded-xl border border-background-200/70 p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-sm"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">{review.content}</p>
                  <p className="text-xs text-foreground-500 font-medium">— {review.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">联系方式</h3>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-mail-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">电子邮箱</p>
                      <p className="text-sm font-medium text-foreground-800">contact@weibamanhua.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                      <i className="ri-wechat-line text-lg text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">微信公众号</p>
                      <p className="text-sm font-medium text-foreground-800">尾巴漫画</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100">
                      <i className="ri-weibo-line text-lg text-secondary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">官方微博</p>
                      <p className="text-sm font-medium text-foreground-800">@尾巴漫画网</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl border border-background-200/70 p-6">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">商务合作</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  如果您有商务合作、广告投放、版权合作等需求，欢迎通过以下方式与我们取得联系。我们期待与您的合作。
                </p>
                <div className="space-y-2 text-sm text-foreground-600">
                  <p>商务邮箱：business@weibamanhua.com</p>
                  <p>工作时间：周一至周五 9:00-18:00</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}